// extracted by css-extract-rspack-plugin
export default {"tab":"tab-WHSKtd","subtleLinkButton":"subtleLinkButton-YAu9l8"};